import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { AppliedPatchGroupViewModel } from '../../models';


export interface ListAppliedPatches$Params {
  patchName?: string;
  dateFrom?: string;
  dateTo?: string;
}

export function ListAppliedPatches(
  http: HttpClient,
  rootUrl: string,
  params?: ListAppliedPatches$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<AppliedPatchGroupViewModel>>> {
  const rb = new RequestBuilder(rootUrl, ListAppliedPatches.PATH, 'get');
  if (params) {
    rb.query('patchName', params.patchName, {});
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AppliedPatchGroupViewModel>>;
    })
  );
}
ListAppliedPatches.PATH = '/api/Developer/ListAppliedPatches';
